import styled from "@emotion/styled";

export const HelpText = styled.span`
  font-size: 12px;
  margin-top: 0.5rem;
`;
